module.exports = __webpack_public_path__ + "affbc7d7997e8fed9b68935b035b0cb1.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/kloudless/icons/gdrive.png
 ** module id = 1477
 ** module chunks = 0
 **/